import * as yup from 'yup'

export const schemaTerminateContractModal = yup.object().shape({
    termination_reason: yup
        .string()
        .required('Termination reason is required')
        .min(10, 'Termination reason must be at least 10 characters')
        .max(1000, 'Termination reason must not exceed 1000 characters'),
    contract_expired_date: yup
        .string()
        .required('Termination date is required'),
})
